(function () {
  const buttons = document.querySelectorAll("button[data-sf-role='toggleLink']");
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      if (!button.closest('.item').classList.contains('active')) {
        button
          .closest('.sf-list')
          .querySelectorAll('.item')
          .forEach((item) => item.classList.remove('active'));
        button.closest('.item').classList.add('active');
      } else {
        button
          .closest('.sf-list')
          .querySelectorAll('.item')
          .forEach((item) => item.classList.remove('active'));
      }
    });
  });
})();
